import { ApiError, ErrorResponseDto } from '@pro4-erp/core-web';
import { apiFetch } from '@/core';
import env from '@/env';
import { AuditVisitRepReviewDetail } from '../types';

type Body = {
  name?: string;
  note?: string;
  validFrom?: string;
  validTo?: string;
  compTypeId?: string;

  [key: string]: any;
};

export const updateAuditorVisitRepReview = async ({
  id,
  data,
}: {
  id: string;
  data: Body;
}): Promise<AuditVisitRepReviewDetail> => {
  const fetchResponse = await apiFetch(
    `${env.VITE_API_URL}/pb/s/api/sqo-portal/audit-visit-rep-review/${id}`,
    {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    }
  );

  if (!fetchResponse.ok) {
    const error = (await fetchResponse.json()) as ErrorResponseDto;
    throw new ApiError(error);
  }

  const response = (await fetchResponse.json()) as AuditVisitRepReviewDetail;
  return response;
};
